import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ExplorerHeaderComponent } from './explorer-header.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { CollapseModule } from 'ngx-bootstrap/collapse';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';

@NgModule({
  declarations: [ExplorerHeaderComponent],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    CollapseModule.forRoot(),
    BsDropdownModule,
    CollapseModule
  ],
  exports: [
    ExplorerHeaderComponent
  ],
  entryComponents: [ExplorerHeaderComponent]

})
export class ExplorerHeaderModule { }
